#import "../fragments/LiveInputMonitoringFragment.graphql"

query StreamMonitoring($contentId: ID!, $from: DateTime!, $to: DateTime!) {
  content(id: $contentId) {
    id
    viewersOnline
    stream {
      id
      monitoring(from: $from, to: $to) {
        ...LiveInputMonitoringFields
      }
    }
  }
}
